module.exports = __webpack_public_path__ + "img/support-of-mallorca-film-comission.7daccbe4.png";